import { Icon } from 'src/components/atoms/Icon';
import TableCell from 'src/components/atoms/TableCell';
import { default as Tag, TagProps } from 'src/components/atoms/Tag';
import Text from 'src/components/atoms/Text';
import styled from 'styled-components/macro';

import { RentVerificationStatus } from 'src/api/rentVerificationApi';
import { formatStatusName, getStatusColor } from './utils';

export const Header = styled.div`
  display: flex;
  padding-left: 5px;

  & > div {
    margin-right: 4rem;
    margin-bottom: 0.75rem;
  }
`;

export const HeaderInfo = styled.div`
  display: flex;
  align-items: center;
  max-width: 45%;

  & > div {
    margin-right: 1rem;
  }

  & > h4 {
    color: ${({ theme }) => theme.color.gray[900]};
  }
`;

export const StyledText = styled(Text)`
  max-width: 100%;
  display: inline;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const StyledIcon = styled(Icon)`
  margin-left: 1rem;
`;

export const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  & > small {
    color: ${({ theme }) => theme.color.blue[700]};
    text-decoration: underline;
  }
`;

export const Content = styled.div`
  width: 100%;
  padding: 2rem;
  border-top: 1px solid ${({ theme }) => theme.color.gray[90]};

  .align-download-button {
    display: inline-flex;
    vertical-align: middle;
  }

  .rent-verification-table {
    overflow-x: visible;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  color: ${({ theme }) => theme.color.blue[700]};

  &[aria-disabled='true'] {
    cursor: unset;
    color: ${({ theme }) => theme.color.gray[300]};

    & > div > div > svg {
      fill: ${({ theme }) => theme.color.gray[300]};
    }
  }
`;

export const StatusLabelCell = styled(TableCell)<{
  status: RentVerificationStatus;
}>`
  color: ${({ theme, status }) => getStatusColor({ theme, status })} !important;
`;

interface StyledTagProps extends TagProps {
  status: RentVerificationStatus;
}

export const StyledTag = styled(Tag).attrs((props: StyledTagProps) => ({
  label: formatStatusName(props.status),
  color: '',
  showBackground: false
}))<StyledTagProps>`
  border: 1px solid;
  ${({ theme, status }) => `${getStatusColor({ theme, status })}`}
`;
